import { SingleShippingEmissionEstimate } from '@lune-climate/lune'
import { SuccessResponseWithMeta } from '@lune-climate/lune/esm/core/SuccessResponse'
import { CalculationResults, Leg, PdfContent } from '@lune-fe/lune-components-lib'
import { Container } from '@lune-fe/lune-ui-lib'
import { Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { getShippingEstimate } from 'endpoints/dapi'
import { useLuneClient } from 'hooks/useLuneClient'
import useTitle from 'hooks/useTitle'
import { EstimateTypeEnum, EstimateTypeName } from 'views/CalculateEmissions'
import SingleLegEstimate from 'views/CalculateEmissions/Logistics/SingleLegEstimate'
import MultiLegEstimate from 'views/CalculateEmissions/MultiLegLogistics/MultiLegEstimate'

const LogisticsEmissionsPdf = () => {
    useTitle('Logistics Emissions')
    const { id, token } = useParams<{ id: string; token: string }>()
    const [estimate, setEstimate] =
        useState<SuccessResponseWithMeta<SingleShippingEmissionEstimate>>()

    const [resolvedLegs] = useState<Leg[]>([])
    const luneClient = useLuneClient()

    useEffect(() => {
        if (id && token) {
            getShippingEstimate(id, token).then((result) => {
                setEstimate(result)

                // window.loadingPdf = 'loaded' will be passed to pdf endpoint to  make sure
                // everything renders before generating the pdf
                setTimeout(() => {
                    window.loadedPdf = 'loaded'
                }, 500)
            })
        }
    }, [id, luneClient, token])

    return (
        <Container
            maxWidth={'md'}
            sx={{
                my: 9,
                px: {
                    xs: 2,
                    sm: 2,
                    md: 2,
                    lg: 0,
                    xl: 0,
                },
            }}
        >
            <PdfContent>
                {estimate && (
                    <>
                        <CalculationResults
                            title={
                                estimate.request.name || EstimateTypeName(EstimateTypeEnum.SHIPPING)
                            }
                            amount={estimate.mass.amount}
                            pdfStructure={true}
                        />
                        <Stack direction={'column'} spacing={9} mt={9}>
                            {resolvedLegs.length ? (
                                <MultiLegEstimate
                                    legs={resolvedLegs}
                                    load={estimate.request.shipment}
                                    meta={estimate._meta}
                                    source={estimate.source}
                                    requestRoute={
                                        'route' in estimate.request
                                            ? estimate.request.route
                                            : undefined
                                    }
                                />
                            ) : (
                                <SingleLegEstimate estimate={estimate} isPdf={true} />
                            )}
                        </Stack>
                    </>
                )}
            </PdfContent>
        </Container>
    )
}

export default LogisticsEmissionsPdf
